import { useMemo } from "react";

export function useFormatEventDetails(eventDate: string) {
  const scheduledTime = new Date(eventDate);

  const day = scheduledTime.toLocaleString("en-US", { weekday: "short" });
  const date = scheduledTime.toLocaleString("en-US", { day: "numeric" });
  const month = scheduledTime.toLocaleString("en-US", { month: "short" });

  const time = scheduledTime.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  const startsIn = useMemo(() => {
    // Find the difference between the current time and the scheduled time
    const diff = scheduledTime.getTime() - Date.now();

    // Convert the difference to minutes
    const minutes = Math.floor(diff / 60000);

    // If the difference is negative, the session has already started
    if (minutes < 0) {
      return "Started";
    }

    // If the difference is less than 60 minutes, show the difference in minutes
    if (minutes < 60) {
      return `Starts in ${minutes}m`;
    }

    // If the difference is less than 24 hours, show the difference in hours
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return `Starts in ${hours}h`;
    }

    // If the difference is more than 24 hours, show the difference in days
    const days = Math.floor(hours / 24);
    return `Starts in ${days}d`;
  }, [scheduledTime]);

  return { day, date, month, time, startsIn };
}
